import * as Role from '../constants/role';
import { isUsuarioUsoMuto } from '../utils';
import { isRoleAuditoriaNsir } from './auditoriaNsirPermission';

/**
 * Mesma regra do menu "Relatórios Digitadores" (Sidebar V1).
 * Usada também para o painel V2 /v2/integracoes.
 */
export function canViewDigitadorReport({ authData, userRole }) {
  if (!authData?.email) return false;
  const role = userRole ?? authData.role;
  const allowedEmails = process.env.REACT_APP_USUARIO_VIEW_DIGITADOR_REPORT?.split(',') ?? [];
  return (
    (allowedEmails.includes(authData.email) || authData.role === Role.DIGITADOR) &&
    !isUsuarioUsoMuto(authData.email) &&
    !isRoleAuditoriaNsir(role)
  );
}
